

import React from "react";
import sigh from "./img/sigh";

const css = require('./index.scss');

export default function WarningContent() {
    return (
        <div className={css.warningContent} >
            <div className={css.head} >
                <span className={css.icon} dangerouslySetInnerHTML={{ __html: sigh }} ></span>
                <span className={css.title} >温馨提示</span>
            </div>
            <div className={css.cont} >
                您尚未开通该服务，请扫描二维码咨询客服人员！
            </div>
            <img src={require('./img/logo2@2x.png')} width={200} style={{ marginBottom: 18 }} alt="" />
            <img src={require('./img/code2x.png')} width={151} alt="" />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/AppResource/WarningContent/index.tsx